import { canOpenStudySource } from '@/composables/studySource'

// 最近播放的两个文件或素材，连同听到的那一句，按账号存在本机；
// 打卡页的“继续练”和素材库的“继续上次练习”从这里续上
const RECENT_LIMIT = 2
const storageKey = uid => `goodscriber:recent-study-sources:${uid}`
const isSameSource = (a, b) => a.audioId === b.audioId && (a.materialId || '') === (b.materialId || '')

export function rememberStudySource(uid, source) {
  if (!uid || !canOpenStudySource(source)) return
  const others = readRecentStudySources(uid).filter(item => !isSameSource(item, source))
  const recent = [{ ...source, playedAt: Date.now() }, ...others].slice(0, RECENT_LIMIT)
  window.localStorage.setItem(storageKey(uid), JSON.stringify(recent))
}

export function readRecentStudySources(uid) {
  if (!uid) return []
  return JSON.parse(window.localStorage.getItem(storageKey(uid)) || '[]')
}

export function readStudySource(uid) {
  return readRecentStudySources(uid)[0] || null
}
